/**
 * Canonical PicoX event fired by global header CTA clicks, shared by the
 * creator-MLP navbar treatment wiring. Schema lives in the PicoX `eventbrite`
 * workspace with tags `["creator_acquisition"]` and data purpose
 * `service_improvement`.
 */
export const HEADER_CTA_CLICKED_EVENT = 'header_cta_clicked';

/** Canonical Janus experiment the header CTA treatments belong to. */
export const HEADER_CREATOR_EXPERIMENT_NAME = 'ebweb_header_creator_conversion_experiment';

/**
 * Maps treatment CTA tracking ids to the canonical PicoX `cta` values.
 * Identifiers not in this mapping return `null` and skip tracking.
 */
const CTA_BY_TRACKING_ID: Record<string, string> = {
  'mlp-webapp-navbar-item-create-events': 'create_events',
  'mlp-webapp-navbar-item-contact-sales': 'contact_sales',
  'mlp-webapp-navbar-item-get-started': 'get_started',
};

export const getHeaderCtaName = (trackingId: string): string | null =>
  CTA_BY_TRACKING_ID[trackingId] ?? null;
